import React from "react";
import Card from "react-bootstrap/Card";
import { styles } from "../../styles/styles.js";
import { StarRating } from "../starrating";
import { isNum } from "../../utils/format.js";

// parseInt(undefined) is NaN, and [...Array(NaN)] throws RangeError — so a
// pitching entry with no star rating used to crash the card rather than omit it.
const toStars = (value) => {
  const parsed = parseInt(value, 10);
  return isNum(parsed) ? parsed : null;
};


const cardStyle = {
  marginBottom: "10px",
  backgroundColor: "black",
  color: "white",
  borderColor: "white",
  borderWidth: 1,
  borderStyle: "solid",
  padding: 20,
};

const headerStyle = {
  fontSize: 'clamp(20px, calc(12px + (11) * ((100vw - 400px) / (1200 - 320))), 30px)',
  fontWeight: 'bold',
  marginBottom: '10px',
  color: 'white'
};

const containerStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
  gap: '20px',
  marginTop: '20px'
};

const Pitchers = ({ fixture }) => {
  if (fixture.league !== "MLB") {
    return null;
  }

  if (!fixture?.stats?.pitching?.[0]) {
    return null;
  }

  const { home_team, away_team } = fixture.stats.pitching[0];

  // The blob path above is guarded; the shape inside it is not. A pitching entry
  // can arrive without a team, or with a team but no named starter.
  if (!home_team?.pitcher || !away_team?.pitcher) {
    return null;
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <h5 style={{ marginBottom: "15px" }}>Starting Pitchers</h5>
      <div style={containerStyle}>
        <Card style={cardStyle}>
          <Card.Body>
            <h3 style={headerStyle}>{away_team.name} {away_team.record}</h3>
            <Card.Text style={styles.analysis}>
              <ul style={{ listStyleType: "none", padding: 0 }}>
                <li>{away_team.pitcher.name} ({away_team.pitcher.hand})</li>
                <li>{away_team.pitcher.era}</li>
                <li>{away_team.pitcher.wins}-{away_team.pitcher.losses}</li>
                <li>{away_team.pitcher.strikeouts}</li>
                <li><StarRating rating={toStars(away_team.pitcher.stars)} /></li>

              </ul>
            </Card.Text>
          </Card.Body>
        </Card>

        <Card style={cardStyle}>
          <Card.Body>
            <h3 style={headerStyle}>{home_team.name} {home_team.record}</h3>
            <Card.Text style={styles.analysis}>
              <ul style={{ listStyleType: "none", padding: 0 }}>
                <li>{home_team.pitcher.name} ({home_team.pitcher.hand})</li>
                <li>{home_team.pitcher.era}</li>
                <li>{home_team.pitcher.wins}-{home_team.pitcher.losses}</li>
                <li>{home_team.pitcher.strikeouts}</li>
                <li><StarRating rating={toStars(home_team.pitcher.stars)} /></li>
              </ul>
            </Card.Text>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default Pitchers;